<div class="my-box">
    <div class="icono text-center">
        <mat-icon [inline]="true">check_circle</mat-icon>
    </div>
    <br/>
    <br/>
    <mat-card-title>{{data['title']}}</mat-card-title>
    <!--    <mat-card-content class="col-md-12 ">{{data['menssageSucces']}}</mat-card-content>-->
    <mat-card-content class="text-center">{{data['menssageSucces']}}</mat-card-content>
    <br/>
    <button mat-raised-button color="accent" class="col-md-12 btn-color" (click)="aceptar()">Aceptar</button>
</div>
